import { PortalAccountDto } from './portalAccountDto';

export interface PortalUserDto {
    portalUserId: number;
    username: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    // phoneNumberExt: string | null;
    doctorHospitalCustomer: string;
    canScheduleCase: boolean | null;
    canScheduleService: boolean | null;
    canScheduleFibers: boolean | null;
    canConfirmCase: boolean | null;
    vendor: boolean | null;
    lithoDoctor: boolean | null;
    portalVendorId: number | null;
    requirePoOnCase: boolean | null;
    lastLoginDate: string | null;
    status: string;
    accounts: PortalAccountDto[];
}

export enum PortalUserRole {
    CanScheduleCase = 1,
    CanConfirmCase = 2,
    Vendor = 3,
}
